module.exports = __webpack_public_path__ + "img/reward-t-shirt.1b6b1dd6.png";